
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { AlertaService } from '../../../services/alerta.service';
import { findAreasCatalogAct, findDivisionsCatalogAct, findWithholdingsCatalogAct, findWithholdingTypeCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, map } from 'rxjs';
import { WithholdingGroup } from '../../../models/withholding-group';
import { Withholding } from '../../../models/withholding';
import { findWithholdingGroupAct, resetWithholdingGroupAct, saveWithholdingGroupAct, updateWithholdingGroupAct } from '../../../store/withholdings-group/withholding-group.action';
import { WithholdingConfiguration } from '../../../models/withholding-configuration';
import { CostsPerEmployeeType } from '../../../models/cost-per-employee-type';
import { WithholdingType } from '../../../models/withholding-type';

@Component({
  selector: 'app-withholdings-add',
  standalone: false,
  templateUrl: './withholdings-add.component.html',
  styleUrl: './withholdings-add.component.css'
})
export class WithholdingsAddComponent {


withholdingGroupForm!: NgForm;
withholdingGroup: WithholdingGroup = new WithholdingGroup();
loading: boolean = false;
violations: any;
divisions: Division[] = [];
areas: Area[] = [];
withholdings: Withholding[] = [];
private alerta = inject(AlertaService);

ngOnInit(): void {
  this.withholdingGroupStore.dispatch(resetWithholdingGroupAct());
  this.route.paramMap.subscribe(params => {
    const id: number = + (params.get('id') || '0');
    if(id > 0){
      this.withholdingGroupStore.dispatch(findWithholdingGroupAct({ id }));
    }else{
      this.withholdingGroup = new WithholdingGroup();
      //this.withholdingGroup.active = true;
      this.loading = false;
    }
  });

  this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
  this.catalogOfferStore.dispatch(findAreasCatalogAct());
  this.catalogOfferStore.dispatch(findWithholdingsCatalogAct());

}
constructor(
  private withholdingGroupStore: Store<{withholdingGroupRdc: any}>,
  private catalogOfferStore: Store<{catalogOfferRdc: any}>,
  private route: ActivatedRoute,
  private cd: ChangeDetectorRef
){
  this.withholdingGroup = new WithholdingGroup();

  this.withholdingGroupStore.pipe(
    select('withholdingGroupRdc'),
    map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
      withholdingGroup: state.withholdingGroup,
      violations: state.violations,
      loading: state.loading
    })),
    // evita repeticiones
    distinctUntilChanged((prev, curr) =>
      JSON.stringify(prev) === JSON.stringify(curr)
    )
  ).subscribe(({ withholdingGroup, violations, loading }) => {
    this.violations = violations;
    this.withholdingGroup = JSON.parse(JSON.stringify(withholdingGroup));
    // Ordenar lista de vacaciones 
    this.withholdingGroup.withholdingConfigurations.sort((a, b) =>  a.withholding.description.localeCompare(b.withholding.description, 'es', { sensitivity: 'base' }) );
    /*this.withholdingGroup.withholdingConfigurations.forEach(withholdingConfiguration => {
      withholdingConfiguration.sort((a, b) => a.initialYear - b.initialYear);
    });*/
    this.loading = loading;
    this.cd.markForCheck(); // fuerza la actualización de la vista

    if(this.withholdingGroupForm){
      Object.keys(this.withholdingGroupForm.controls).forEach(controlName => {
        const control = this.withholdingGroupForm.controls[controlName];
        if (this.violations[controlName]) {
          control.setErrors({ backend: true }); // Marca error
        }
      });
    }
  });

  this.catalogOfferStore.pipe(
    select('catalogOfferRdc'),
    map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
      divisions: state.divisions,
      areas: state.areas,
      withholdings: state.withholdings
    })),
    // evita repeticiones
    distinctUntilChanged((prev, curr) =>
      JSON.stringify(prev) === JSON.stringify(curr)
    )
  ).subscribe(({ divisions, areas, withholdings }) => {
    this.divisions = divisions;
    this.areas = areas;
    this.withholdings = withholdings;
  });
  
}

onSubmitWithholdingGroup(withholdingGroupForm: NgForm): void {
  this.loading = true;
  this.withholdingGroupForm = withholdingGroupForm;
  const withholdingGroupCopy = JSON.parse(JSON.stringify(this.withholdingGroup));

  if (withholdingGroupCopy.id > 0) {
    this.withholdingGroupStore.dispatch(updateWithholdingGroupAct({ withholdingGroupUpdated: withholdingGroupCopy }))
  } else {
    this.withholdingGroupStore.dispatch(saveWithholdingGroupAct({ withholdingGroupNew: withholdingGroupCopy }))
  }
}

addWithholdingConf(){
  const newWithholdingConfigurations = new WithholdingConfiguration();
  this.withholdingGroup.withholdingConfigurations = [...this.withholdingGroup.withholdingConfigurations, newWithholdingConfigurations ];
}

  hoveredRow: number | null = null;
  hoveredCol: number | null = null;

  isSelected(listIndex: number, divisionId: number, areaId: number): boolean {
    const list = this.withholdingGroup.withholdingConfigurations?.[listIndex];
    return list?.withholdingDivisionAreaList.some(d =>
      d.id.divisionId === divisionId && d.id.areaId === areaId
    ) ?? false;
  }

  onCheckboxChange(listIndex: number, division: Division, area: Area, event: any): void {
    const checked = event.target.checked;
    const list = this.withholdingGroup.withholdingConfigurations?.[listIndex];
    if (!list) return;
  
    const index = list.withholdingDivisionAreaList.findIndex(d =>
      d.id.divisionId === division.id && d.id.areaId === area.id
    );
  
    if (checked && index === -1) {
      // Agrega nuevo vínculo
      list.withholdingDivisionAreaList.push({
        id: {
          holidayListId: list.id,
          divisionId: division.id,
          areaId: area.id
        },
        division,
        area
      });
    } else if (!checked && index !== -1) {
      // Elimina vínculo
      list.withholdingDivisionAreaList.splice(index, 1);
    }
  }
  onMouseEnter(row: number, col: number) {
    this.hoveredRow = row;
    this.hoveredCol = col;
  }

  onMouseLeave() {
    this.hoveredRow = null;
    this.hoveredCol = null;
  }

  compareWithholding = (a: any, b: any) => a?.id === b?.id;
  
}
